var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRepetitions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "22px",
    viewBox: "0 0 21 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Repetitions") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2B50-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-42.000000, -289.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Other-/-Navigation",
    transform: "translate(20.000000, 248.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(22.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)",
    fill: "#D8D8D8",
    id: "Rectangle",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(2.000000, 2.000000)",
    stroke: "#EEAC84",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6971118,3.94247759 C13.1005049,2.18776461 10.7206933,1.45172999 8.85424356,1.45172999 C3.71660828,1.45172999 0,5.30437673 0,10.3765209 C0,15.4486651 3.7249807,19.2374216 8.85424356,19.2374216 C13.9835064,19.2374216 17.2272405,15.201921 17.5846193,11.5548198",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.6327187,
    y1: 4.65518308,
    x2: 12.0214265,
    y2: 6.37450133,
    id: "Path-4",
    transform: "translate(13.827073, 5.514842) rotate(20.000000) translate(-13.827073, -5.514842) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.5803883,
    y1: 1,
    x2: 15.2960153,
    y2: 5.23258143,
    id: "Path-4",
    transform: "translate(15.938202, 3.116291) scale(1, -1) rotate(-20.000000) translate(-15.938202, -3.116291) "
  })))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepetitions);
export default __webpack_public_path__ + "static/media/repetitions.16236a67d208c6a063fd8e2d0b5251c8.svg";
export { ForwardRef as ReactComponent };